module.exports = __webpack_public_path__ + "img/level1.597e18a6.png";